import { useEffect } from "react";

function isErrorWithMessage(obj: unknown): obj is { message: string } {
  return (
    typeof obj === "object" &&
    obj !== null &&
    "message" in obj &&
    typeof obj.message === "string"
  );
}

/**
 * Hook that handles dynamic import errors by reloading the page when stale bundles are detected.
 * This prevents users from seeing errors when the application has been updated and their cached
 * bundles are no longer available.
 *
 * Ideally in the future we would avoid this error altogether by keeping old bundles available for some period of time
 * and prompting the user to refresh the page when a new version of the app is available.
 *
 * @param error - The error object to check for dynamic import failures (from useRouteError)
 */
export function useDynamicImportErrorHandler(error: unknown) {
  useEffect(() => {
    if (
      isErrorWithMessage(error) &&
      (error.message.includes("Failed to fetch dynamically imported module") ||
        error.message.includes("Importing a module script failed"))
    ) {
      const reloadTimestamp = parseInt(
        sessionStorage.getItem("oneleet_already_reloaded") || "0",
      );

      // Only reload if the reload meta is older than 1 minute
      if (Date.now() - reloadTimestamp > 1000 * 60) {
        sessionStorage.setItem(
          "oneleet_already_reloaded",
          Date.now().toString(),
        );
        window.location.reload();
      }
    }
  }, [error]);
}
